import SeatingStatus from '@/views/SeatingStatus'

export default [
  {
    path: '/seating-status',
    name: 'seating-status',
    component: SeatingStatus
  }
]
